import { render, staticRenderFns } from "./NewEdit.vue?vue&type=template&id=755b5a24&"
import script from "./NewEdit.vue?vue&type=script&lang=js&"
export * from "./NewEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports